export const getListPackage = async (params = {}) => {
  return {
    data: {
      errorCode: 0,
      groupServices: [
        {
          groupCode: "METFONE_TV360",
          groupName: "METFONE_TV360",
          groupOrder: 2,
          services: [
            {
              content:
                "Watch local & international channels | Khmer-dubbed movies and entertainment",
              fullDes:
                'You are buying a TV360 Monthly Package: <br>• Internet data: 60GB<br><div style="margin-left: 10px;">• 30GB for all internet uses</div><div style="margin-left: 10px;">• 30GB for using Chinese Mobile Apps (iQIYI Video, Mangguo TV, Tencent Video, CCTV Video, Migu Video, Youku Video, Bilibili, AcFun, Sohu TV, PPTV, Kugou Music, Netease Music, Kuwo Music, QQ Music, Migu Music).</div>• Validity of package: 30 days',
              iconUrl: "https://i.postimg.cc/5tsdWn2x/Data-Osja-Monthly4.png",
              price: 0.1,
              serviceCode: "METFONE_TV360_Monthly_1",
              serviceName: "Chinese Monthly 1",
              serviceOrder: "1",
              shortDes:
                "60GB (30GB for all internet uses + 30GB for using Chinese Mobile Apps)",
              tv360PackageGroupId: "1",
              tv360PackageId: "3",
              unit: "$",
              validity: "30 days",
            },

            {
              content:
                "Watch local & international channels | Khmer-dubbed movies and entertainment",
              fullDes:
                'You are buying a TV360 Monthly Package: <br>• Internet data: 60GB<br><div style="margin-left: 10px;">• 30GB for all internet uses</div><div style="margin-left: 10px;">• 30GB for using Chinese Mobile Apps (iQIYI Video, Mangguo TV, Tencent Video, CCTV Video, Migu Video, Youku Video, Bilibili, AcFun, Sohu TV, PPTV, Kugou Music, Netease Music, Kuwo Music, QQ Music, Migu Music).</div>• Validity of package: 30 days',
              iconUrl: "https://i.postimg.cc/5tsdWn2x/Data-Osja-Monthly4.png",
              price: 0.1,
              serviceCode: "METFONE_TV360_Monthly_2",
              serviceName: "Chinese Monthly 2",
              serviceOrder: "1",
              shortDes:
                "60GB (30GB for all internet uses + 30GB for using Chinese Mobile Apps)",
              tv360PackageGroupId: "1",
              tv360PackageId: "3",
              unit: "$",
              validity: "30 days",
            },

            {
              content:
                "Watch local & international channels | Khmer-dubbed movies and entertainment",
              fullDes:
                'You are buying a TV360 Monthly Package: <br>• Internet data: 60GB<br><div style="margin-left: 10px;">• 30GB for all internet uses</div><div style="margin-left: 10px;">• 30GB for using Chinese Mobile Apps (iQIYI Video, Mangguo TV, Tencent Video, CCTV Video, Migu Video, Youku Video, Bilibili, AcFun, Sohu TV, PPTV, Kugou Music, Netease Music, Kuwo Music, QQ Music, Migu Music).</div>• Validity of package: 30 days',
              iconUrl: "https://i.postimg.cc/5tsdWn2x/Data-Osja-Monthly4.png",
              price: 0.1,
              serviceCode: "METFONE_TV360_Monthly_3",
              serviceName: "Chinese Monthly 3",
              serviceOrder: "1",
              shortDes:
                "60GB (30GB for all internet uses + 30GB for using Chinese Mobile Apps)",
              tv360PackageGroupId: "1",
              tv360PackageId: "3",
              unit: "$",
              validity: "30 days",
            },

            {
              content:
                "Watch local & international channels | Khmer-dubbed movies and entertainment",
              fullDes:
                'You are buying a TV360 Monthly Package: <br>• Internet data: 60GB<br><div style="margin-left: 10px;">• 30GB for all internet uses</div><div style="margin-left: 10px;">• 30GB for using Chinese Mobile Apps (iQIYI Video, Mangguo TV, Tencent Video, CCTV Video, Migu Video, Youku Video, Bilibili, AcFun, Sohu TV, PPTV, Kugou Music, Netease Music, Kuwo Music, QQ Music, Migu Music).</div>• Validity of package: 30 days',
              iconUrl: "https://i.postimg.cc/5tsdWn2x/Data-Osja-Monthly4.png",
              price: 0.1,
              serviceCode: "METFONE_TV360_Monthly_4",
              serviceName: "Chinese Monthly 4",
              serviceOrder: "1",
              shortDes:
                "60GB (30GB for all internet uses + 30GB for using Chinese Mobile Apps)",
              tv360PackageGroupId: "1",
              tv360PackageId: "3",
              unit: "$",
              validity: "30 days",
            },
          ],
        },
      ],
    },
  };
};

export const getHistoryPackageTV360 = async (params = {}) => {
  const base = [];
  const icon = "https://i.postimg.cc/5tsdWn2x/Data-Osja-Monthly4.png";
  const possibleStatuses = ["0", "1", "2"];
  for (let i = 1; i <= 24; i++) {
    const status =
      possibleStatuses[Math.floor(Math.random() * possibleStatuses.length)];
    let updateDate = null;
    if (Math.random() > 0.2) {
      const minutesAgo = Math.floor(Math.random() * 120);
      updateDate = new Date(Date.now() - minutesAgo * 60 * 1000).toISOString();
    }

    const registerMinutesAgo = Math.floor(Math.random() * 1000);
    const registerDate = new Date(
      Date.now() - registerMinutesAgo * 60 * 1000,
    ).toISOString();

    base.push({
      code: `METFONE_TV360_Monthly_${i}`,
      iconUrl: icon,
      name: `Chinese Monthly ${i}`,
      price: 0.1,
      registerDate: registerDate,
      requestId: `mock_req_00123456789_${i}`,
      shortDes:
        "60GB (30GB for all internet uses + 30GB for using Chinese Mobile Apps)",
      status: status,
      unit: "$",
      validity: "30 days",
      updateDate: updateDate,
    });
  }

  // pagination params
  const page = parseInt(params.page, 10) || 1;
  const pageSize = parseInt(params.pageSize, 10) || 4;

  const totalItems = base.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const currentPage = Math.max(1, Math.min(page, totalPages));
  const start = (currentPage - 1) * pageSize;
  const services = base.slice(start, start + pageSize);

  return {
    data: {
      errorCode: 0,
      currentPage: currentPage,
      totalPages: totalPages,
      totalItems: totalItems,
      services: services,
    },
  };
};

export const preBuyPackageTv360ABA = async (params = {}) => {
  return {
    data: {
      errorCode: 0, // 0:success || 1:showProcessingDialog  || 2:showFailDialog
      message: "Mock preBuyPackageTv360ABA successful",
      amount: 3.0,
      hashPayment: "mcok_abc123def456ghi789",
      requestId: "mock_req_00123456789",
    },
  };
};

export const checkPaymentStatusABA = async (params = {}) => {
  return {
    data: {
      errorCode: 0, // 0: success
      message: "Mock checkPaymentStatusABA successful",
      checkStatusResponseDTO: {
        state: 5000, // 5000: goto Buy || 3000: retry payment
        paymentReference: "Mock checkPaymentStatusABA successful",
        paymentStatus: "SUCCESS",
      },
    },
  };
};

export const buyPackageTv360ABA = async (params = {}) => {
  return {
    data: {
      errorCode: 1, //0: success || 1: request received || 2: fail
      //transactionId: "mock_txn_00123456789",
      message: "Mock buyPackageTv360ABA successful",
    },
  };
};

export const syncTransT360 = async (params = {}) => {
  return {
    data: {
      errorCode: 0, //0: success || other: fail
      message: "Mock syncTransT360 successful",
    },
  };
};

export default {
  getListPackage,
  preBuyPackageTv360ABA,
  buyPackageTv360ABA,
  checkPaymentStatusABA,
  getHistoryPackageTV360,
  syncTransT360,
};
